import { Suspense, lazy, FC } from 'react';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';

const PdpSharedReminderLazy = lazy(() =>
    import(
        /* webpackChunkName: "PdpSharedReminderWrapper" */
        './PdpSharedReminderWrapper'
    ).then(moduleExport => ({ default: moduleExport.PdpSharedReminderWrapper }))
);

type Props = {
    load: boolean;
    relayVariables: {
        userId: string;
        fetchUser: boolean;
        itemId: string;
        isClient: boolean;
    };
};

const PdpSharedReminderLoader: FC<Props> = props => {
    if (!props.load) {
        return null;
    }
    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={null}>
                <PdpSharedReminderLazy {...props} />
            </Suspense>
        </ErrorBoundary>
    );
};

export { PdpSharedReminderLoader };
